module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./apps/nox/src/app/app.component.css
// module id = ./apps/nox/src/app/app.component.css
// module chunks = main